<style lang="scss" scoped>
  @import "../../../scss/app";

  $sidebar-width: 300px;

  #toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 20;
  }

  #sidebar {
    background-color: #fff;
    width: $sidebar-width;
    position: absolute;
    top: 64px;
    bottom: 0;
    overflow: auto;
  }

  .content {
    position: relative;
    background-color: $light-grey;
    padding-top: 64px;
    height: 100%;
  }

  .page-content {
    padding-left: $sidebar-width;
    overflow: auto;
    height: 100%;
  }
</style>

<template>
  <div class="full-height">
    <md-sidenav class="md-left" ref="sidenav">

      <div class="bg-blue px2 pb2 pt4" v-if="user">
        <div class="fz24">{{ user.name }}</div>
        <p>{{ user.store.name }}</p>
      </div>

      <md-list @click.native="$refs.sidenav.close()">
        <md-list-item>
          <router-link :to="{name: 'shop'}" ex>Nettbutikk</router-link>
        </md-list-item>
        <md-list-item>
          <router-link :to="{name: 'settings'}">Innstillinger</router-link>
        </md-list-item>
      </md-list>

      <div class="border-bottom border-light-grey"></div>

      <md-list @click.native="$refs.sidenav.close()">
        <md-list-item>
          <router-link :to="{name: 'logout'}">Logg ut</router-link>
        </md-list-item>
      </md-list>

    </md-sidenav>

    <div id="toolbar">
      <md-theme md-name="white">
        <md-toolbar class="sh2">
          <md-button class="md-icon-button" @click="toggleSidenav">
            <md-icon>menu</md-icon>
          </md-button>

          <div class="flex-auto center">
            <img src="/static/img/ui/copy_print_logo.svg" alt="MyOrder" width="110" class="mr1">
          </div>

          <div class="mr2">
            <!--
            <md-button class="md-icon-button text-grey">
              <md-icon>search</md-icon>
            </md-button>
            -->

            <md-button class="md-icon-button md-has-notification text-grey" @click.native="viewCart()">
              <md-tooltip>Handlekurv</md-tooltip>
              <md-notification class="md-blue" v-if="$root.$data.cart">{{ $root.$data.cart.items.length }}</md-notification>
              <md-icon>shopping_cart</md-icon>
            </md-button>

            <!--
            <md-button class="md-icon-button md-has-notification text-grey">
              <md-notification>1</md-notification>
              <md-icon>forum</md-icon>
            </md-button>

            <md-button class="md-icon-button md-has-notification text-grey">
              <md-notification>20</md-notification>
              <md-icon>notifications</md-icon>
            </md-button>
            <md-button class="md-icon-button md-has-notification text-grey" @click.native="$router.push('/logout')">
              <md-tooltip>Logg ut</md-tooltip>
              <md-icon>exit_to_app</md-icon>
            </md-button>

            -->
          </div>
        </md-toolbar>
      </md-theme>
    </div>

    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import apiCart from '@/js/api/cart';
  import apiMe from '@/js/api/me';

  export default {
    data() {
      return {
        cart: null,
        user: null,
      };
    },

    mounted() {
      // this.state.start('loading');
      apiCart.get().then(this.onCartSuccess);
      apiMe.show().then(this.onMeSuccess);
    },

    methods: {
      toggleSidenav() {
        this.$refs.sidenav.toggle();
      },

      onCartSuccess(cart) {
        apiCart.show(cart.id).then(this.onFetchSuccess);
      },

      onMeSuccess(response) {
        this.user = response.data.data;
      },

      onFetchSuccess(response) {
        this.cart = response.data.data;
        // this.state.stop('loading');
      },

      viewCart() {
        this.$router.push({ name: 'cart' });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Main.vue?d2d3f04c